/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Section_RecipientInputs */

const vi_cdo_section_recipient = /** @type {(inputs: Cdo_Section_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin người nhận`)
};

/**

* @param {Cdo_Section_RecipientInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_section_recipient = /** @type {((inputs?: Cdo_Section_RecipientInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Section_RecipientInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_section_recipient(inputs)
});